<div class="l-main__contents js-fit-contents">
  <app-breadcrumbs [label2]="title"></app-breadcrumbs>
  <h1 class="c-texts--head1">{{ title }}</h1>

  <div class="c-notification-list-section">
    <div *ngIf="petaboNotificationList.length === 0 && !loading" class="c-empty-state">
      <div class="empty-icon">📋</div>
      <p class="empty-message">現在動画はありません</p>
    </div>

    <div *ngIf="petaboNotificationList.length > 0">
      <div *ngFor="let groupKey of groupKeys" class="c-video-group">
        <h2 class="c-video-group-title">{{ groupKey }}</h2>
        <div [class]="groupedNotifications[groupKey].length === 1 ? 'c-video-card-list-single' : 'c-video-card-list'">
          <div
            *ngFor="let video of groupedNotifications[groupKey]; let i = index"
            class="c-video-card-item"
            (click)="notificationLink(video.profiles.url)"
            ActionTransaction
            [commandCd]="viewCd + '-clickPetabo-' + video.id"
          >
            <div class="video-image-container">
              <img
                *ngIf="video.profiles?.imageUrl"
                [src]="video.profiles.imageUrl"
                [alt]="video.name"
                class="video-thumbnail"
                (error)="onImageError($event)"
              />
              <div *ngIf="!video.profiles?.imageUrl" class="video-placeholder">🎬</div>
              <div class="video-play-overlay">
                <div class="play-button">▶</div>
              </div>
            </div>
            <div class="video-content">
              <div class="video-meta">
                <span class="video-date" *ngIf="video.profiles?.periodFrom">
                  {{ video.profiles.periodFrom | date : 'yyyy/MM/dd' }}
                </span>
              </div>
              <h3 class="video-title">
                {{ video.name }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
